module.exports = __webpack_public_path__ + "img/1.f7c8d2e8.jpg";